// extracted by mini-css-extract-plugin
export default {"heading":"DeafCommJoinPage_heading__-5Ssl","content":"DeafCommJoinPage_content__IOXLM"};